import moment from "moment";

export default function (date, template = "DD/MM/YYYY HH:mm") {
  if (!date) {
    return template.replace(/[^/]/g, "-");
  }

  return moment(date).isValid() ? moment(date).format(template) : date;
}
